import { makeStyles } from "@material-ui/core/styles";
import { MYCOLORS } from "../../mypallette";

import Color from "color";

export const useProjectStyles = makeStyles(() => ({
  cardmainLight: {
    minWidth: 275,
    //background: MYCOLORS.lback,
    background: `linear-gradient(0.5turn, ${MYCOLORS.lcard}, ${MYCOLORS.lhighlight}, ${MYCOLORS.lcard})`,
  },
  cardmainDark: {
    minWidth: 275,
    background: `linear-gradient(0.5turn, ${MYCOLORS.dcard}, ${MYCOLORS.lpaper}, ${MYCOLORS.dcard})`,
  },
  actionArea: {
    borderRadius: 16,
    transition: "0.2s",
    "&:hover": {
      transform: "scale(1.05)",
    },
  },
  card: ({ color }) => ({
    minWidth: 275,
    width: "85vw", // up to maximum of the outer card max size of lg

    borderRadius: 16,
    //boxShadow: "none",
    "&:hover": {
      boxShadow: `0 6px 12px 0 ${Color(color).rotate(-12).darken(0.2).fade(0.5)}`,
    },
  }),
  cardLarge: ({ color }) => ({
    minWidth: 275,
    width: "1088px", // 1024px is 80% of lg/1280 up to maximum of the outer card max size of lg

    borderRadius: 16,
    //boxShadow: "none",
    "&:hover": {
      boxShadow: `0 6px 12px 0 ${Color(color).rotate(-12).darken(0.2).fade(0.5)}`,
    },
  }),
  content: ({ color }) => {
    return {
      backgroundColor: color,
      padding: "1rem 1.5rem 1.5rem",
    };
  },
  title: {
    fontFamily: "Keania One",
    fontSize: "2rem",
    color: "#fff",
    textTransform: "uppercase",
  },
  subtitle: {
    
    fontFamily: "Montserrat",
    color: "#fff",
    opacity: 0.87,
    marginTop: "1rem",
    fontWeight: 500,
    fontSize: 16,
  },
  cardMedia: {
    display: "inline",
    transitionDuration: "0.3s",
    height: "50vh",
    objectFit: "cover",
  },
}));
